
import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import {
    addContactCategoryRequest, addContactRequest, addPhoneBookRequest, contactListToBlockRequest, copyByContactRequest, copyByPhonebookRequest,
    getAllContactCategoryRequest, getAllContactRequest, getContactRequest, getContactsByPhoneBookIdRequest, getPhoneBooksRequest, moveByContactRequest,
    moveByPhonebookRequest, removeContactCategoryRequest, removeContactRequest, removeFromPhoneBookContactRequest, removePhoneBookRequest,
    updateContactCategoryRequest, updateContactRequest, updatePhoneBookRequest
} from "../apiRequests/contactRequests";
import {
    AddContactCategoryErrorAction, AddContactCategorySuccessAction, addContactErrorAction, addContactSuccessAction, AddPhoneBookErrorAction,
    AddPhoneBookSuccessAction, ContactListToBlockErrorAction, ContactListToBlockSuccessAction, CopyByContactErrorAction, CopyByContactSuccessAction,
    CopyByPhonebookErrorAction, CopyByPhonebookSuccessAction,
    getContactCategoryErrorAction, getContactCategorySuccessAction, getContactsByPhoneBookIdErrorAction, getContactsByPhoneBookIdSuccessAction,
    getPhoneBooksErrorAction, getPhoneBooksSuccessAction, GetUnpagedPhonebookErrorAction,
    GetUnpagedPhonebookSuccessAction, MoveByContactErrorAction, MoveByContactSuccessAction, MoveByPhonebookErrorAction,
    MoveByPhonebookSuccessAction, RemoveContactCategoryErrorAction, RemoveContactCategorySuccessAction, removeContactErrorAction, removeContactSuccessAction,
    removeFromPhoneBookContactErrorAction, removeFromPhoneBookContactSuccessAction,
    removePhoneBookErrorAction, removePhoneBookSuccessAction, UpdateContactCategoryErrorAction, UpdateContactCategorySuccessAction,
    updateContactErrorAction, updateContactSuccessAction, UpdatePhoneBookErrorAction, UpdatePhoneBookSuccessAction, getAllContactsErrorAction, getAllContactsSuccessAction, getContactErrorAction, getContactSuccessAction, getUnpagedContactSuccessAction, getUnpagedContactErrorAction, getContactCallDirectSuccessAction, getContactCallDirectErrorAction
} from "../../actions/contactActions";
import { ContactDataObject, PhoneBookDataObject } from "../../interfaces/contacts";



function* getContactRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(getAllContactRequest, action.payload)
        yield put(
            getAllContactsSuccessAction(response.data)
        )
    } catch (error: any) {
        yield put(
            getAllContactsErrorAction({
                error: error.message
            })
        )
    }
}

function* getContactCallDirectRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(getContactRequest, action.payload)
        yield put(
            getContactCallDirectSuccessAction(response.data)
        )
    } catch (error: any) {
        yield put(
            getContactCallDirectErrorAction({
                error: error.message
            })
        )
    }
}

function* getContactsByPhoneBookIdRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(getContactsByPhoneBookIdRequest, action.payload)
        yield put(
            getContactsByPhoneBookIdSuccessAction(response.data)
        )
    } catch (error: any) {
        yield put(
            getContactsByPhoneBookIdErrorAction({
                error: error.message
            })
        )
    }
}

function* addContactRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(addContactRequest, action.payload)
        yield put(
            addContactSuccessAction()
        )
    } catch (error: any) {
        yield put(
            addContactErrorAction({
                error: error.message
            })
        )
    }
}
function* getContactsRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(getContactRequest, action.payload)
        const contacts = new ContactDataObject(response.data)
        yield put(
            getContactSuccessAction(contacts)
        )
    } catch (error: any) {
        yield put(
            getContactErrorAction({
                error: error.message
            })
        )
    }
}

function* getUnpagedContactsRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(getContactRequest, action.payload)
        const contacts = new ContactDataObject(response.data)
        yield put(
            getUnpagedContactSuccessAction(contacts)
        )
    } catch (error: any) {
        yield put(
            getUnpagedContactErrorAction({
                error: error.message
            })
        )
    }
}

function* updateContactRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(updateContactRequest, action.payload)
        yield put(
            updateContactSuccessAction()
        )
    } catch (error: any) {
        yield put(
            updateContactErrorAction({
                error: error.message
            })
        )
    }
}
function* removeFromPhoneBookContactRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(removeFromPhoneBookContactRequest, action.payload)
        yield put(
            removeFromPhoneBookContactSuccessAction()
        )
    } catch (error: any) {
        yield put(
            removeFromPhoneBookContactErrorAction({
                error: error.message
            })
        )
    }
}
function* removeContactRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(removeContactRequest, action.payload)
        yield put(
            removeContactSuccessAction()
        )
    } catch (error: any) {
        yield put(
            removeContactErrorAction({
                error: error.message
            })
        )
    }
}

function* getContactCategoryRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(getAllContactCategoryRequest, action.payload)
        yield put(
            getContactCategorySuccessAction(response.data)
        )
    } catch (error: any) {
        yield put(
            getContactCategoryErrorAction({
                error: error.message
            })
        )
    }
}
function* addContactCategoryRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(addContactCategoryRequest, action.payload)
        yield put(
            AddContactCategorySuccessAction()
        )
    } catch (error: any) {
        yield put(
            AddContactCategoryErrorAction({
                error: error.message
            })
        )
    }
}
function* updateContactCategoryRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(updateContactCategoryRequest, action.payload)
        yield put(
            UpdateContactCategorySuccessAction()
        )
    } catch (error: any) {
        yield put(
            UpdateContactCategoryErrorAction({
                error: error.message
            })
        )
    }
}
function* removeContactCategoryRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(removeContactCategoryRequest, action.payload)
        yield put(
            RemoveContactCategorySuccessAction()
        )
    } catch (error: any) {
        yield put(
            RemoveContactCategoryErrorAction({
                error: error.message
            })
        )
    }
}


function* getPhoneBookRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(getPhoneBooksRequest, action.payload)
        let phoneBookResponse = new PhoneBookDataObject(response.data)
        yield put(
            getPhoneBooksSuccessAction(phoneBookResponse)
        )
    } catch (error: any) {
        yield put(
            getPhoneBooksErrorAction({
                error: error.message
            })
        )
    }
}

function* addPhoneBookRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(addPhoneBookRequest, action.payload)
        yield put(
            AddPhoneBookSuccessAction()
        )
    } catch (error: any) {
        yield put(
            AddPhoneBookErrorAction({
                error: error.message
            })
        )
    }
}

function* updatePhoneBookRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(updatePhoneBookRequest, action.payload)
        yield put(
            UpdatePhoneBookSuccessAction()
        )
    } catch (error: any) {
        yield put(
            UpdatePhoneBookErrorAction({
                error: error.message
            })
        )
    }
}

function* deletePhoneBookRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(removePhoneBookRequest, action.payload)
        yield put(
            removePhoneBookSuccessAction()
        )
    } catch (error: any) {
        yield put(
            removePhoneBookErrorAction({
                error: error.message
            })
        )
    }
}


function* copyByPhonebookRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(copyByPhonebookRequest, action.payload)
        yield put(
            CopyByPhonebookSuccessAction()
        )
    } catch (error: any) {
        yield put(
            CopyByPhonebookErrorAction({
                error: error.message
            })
        )
    }
}


function* moveByPhonebookRequestHandler(action: any) {
    try {

        const response: { data: any } = yield call(moveByPhonebookRequest, action.payload)
        yield put(
            MoveByPhonebookSuccessAction()
        )
    } catch (error: any) {
        yield put(
            MoveByPhonebookErrorAction({
                error: error.message
            })
        )
    }
}



function* getUnpagedPhonebookRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(getPhoneBooksRequest, action.payload)
        let phoneBookResponse = new PhoneBookDataObject(response.data)
        yield put(
            GetUnpagedPhonebookSuccessAction(phoneBookResponse)
        )
    } catch (error: any) {
        yield put(
            GetUnpagedPhonebookErrorAction({
                error: error.message
            })
        )
    }
}


function* copyByContactRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(copyByContactRequest, action.payload)
        yield put(
            CopyByContactSuccessAction()
        )
    } catch (error: any) {
        yield put(
            CopyByContactErrorAction({
                error: error.message
            })
        )
    }
}


function* moveByContactRequestHandler(action: any) {
    try {

        const response: { data: any } = yield call(moveByContactRequest, action.payload)
        yield put(
            MoveByContactSuccessAction()
        )
    } catch (error: any) {
        yield put(
            MoveByContactErrorAction({
                error: error.message
            })
        )
    }
}


function* updateBlockContactListRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(contactListToBlockRequest, action.payload)
        yield put(
            ContactListToBlockSuccessAction()
        )
    } catch (error: any) {
        yield put(
            ContactListToBlockErrorAction({
                error: error.message
            })
        )
    }
}



function* contactSaga() {

    yield all([takeLatest(Types.GET_ALL_CONTACTS_REQUEST, getContactRequestHandler)]);
    yield all([takeLatest(Types.GET_CONTACTS_BY_PHONE_BOOK_ID_REQUEST, getContactsByPhoneBookIdRequestHandler)]);
    yield all([takeLatest(Types.ADD_CONTACT_REQUEST, addContactRequestHandler)]);
    yield all([takeLatest(Types.UPDATE_CONTACT_REQUEST, updateContactRequestHandler)]);
    yield all([takeLatest(Types.REMOVE_FROM_PHONE_BOOK_CONTACT_REQUEST, removeFromPhoneBookContactRequestHandler)]);
    yield all([takeLatest(Types.REMOVE_CONTACT_REQUEST, removeContactRequestHandler)]);
    yield all([takeLatest(Types.GET_CONTACT_CATEGORY_REQUEST, getContactCategoryRequestHandler)]);
    yield all([takeLatest(Types.ADD_CONTACT_CATEGORY_REQUEST, addContactCategoryRequestHandler)]);
    yield all([takeLatest(Types.UPDATE_CONTACT_CATEGORY_REQUEST, updateContactCategoryRequestHandler)]);
    yield all([takeLatest(Types.REMOVE_CONTACT_CATEGORY_REQUEST, removeContactCategoryRequestHandler)]);
    yield all([takeLatest(Types.GET_PHONE_BOOKS_REQUEST, getPhoneBookRequestHandler)]);
    yield all([takeLatest(Types.ADD_PHONE_BOOK_REQUEST, addPhoneBookRequestHandler)]);
    yield all([takeLatest(Types.UPDATE_PHONE_BOOK_REQUEST, updatePhoneBookRequestHandler)]);
    yield all([takeLatest(Types.DELETE_PHONE_BOOK_REQUEST, deletePhoneBookRequestHandler)]);
    yield all([takeLatest(Types.COPY_BY_PHONEBOOK_REQUEST, copyByPhonebookRequestHandler)]);
    yield all([takeLatest(Types.MOVE_BY_PHONEBOOK_REQUEST, moveByPhonebookRequestHandler)]);
    yield all([takeLatest(Types.GET_PHONEBOOK_UNPAGED_REQUEST, getUnpagedPhonebookRequestHandler)]);
    yield all([takeLatest(Types.COPY_BY_CONTACT_REQUEST, copyByContactRequestHandler)]);
    yield all([takeLatest(Types.MOVE_BY_CONTACT_REQUEST, moveByContactRequestHandler)]);
    yield all([takeLatest(Types.CONTACT_LIST_TO_BLOCK_REQUEST, updateBlockContactListRequestHandler)]);
    yield all([takeLatest(Types.GET_CONTACT_REQUEST, getContactsRequestHandler)]);
    yield all([takeLatest(Types.GET_UNPAGED_CONTACT_REQUEST, getUnpagedContactsRequestHandler)]);
    yield all([takeLatest(Types.GET_CONTACT_CALL_DIRECT_REQUEST, getContactCallDirectRequestHandler)]);









}

export default contactSaga